import * as moment from 'moment';

export const formatDateTime = (value: string | null) => value ? moment(value, 'YYYY-MM-DDTHH:mm').format('MM/DD/YY HH:mm') : '';
